import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CalculatorCardProps {
  icon?: LucideIcon;
  title: string;
  subtitle?: string;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
}

export const CalculatorCard: React.FC<CalculatorCardProps> = ({
  icon: Icon,
  title,
  subtitle,
  isActive,
  onClick,
  className
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'p-4 rounded-xl border-2 transition-all text-left',
        isActive
          ? 'border-orange-500 bg-orange-500/10'
          : 'border-zinc-700 hover:border-zinc-600',
        className
      )}
    >
      {Icon && (
        <Icon className={cn(
          'w-8 h-8 mb-2',
          isActive ? 'text-orange-500' : 'text-gray-400'
        )} />
      )}
      <p className="font-medium">{title}</p>
      {subtitle && (
        <p className="text-sm text-gray-400 mt-1">{subtitle}</p>
      )}
    </button>
  );
};
